module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/american_express-8045833385c9f0ac074242c893de7b2e.png";